import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en.json";
import cs from "./cs.json";

// Get saved language from localStorage or default to English
const savedLanguage = localStorage.getItem("plotcat-ui-language") || "en";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      cs: { translation: cs },
    },
    lng: savedLanguage,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // React already handles XSS protection
    },
  });

// Save language preference when it changes
i18n.on("languageChanged", (lng) => {
  localStorage.setItem("plotcat-ui-language", lng);
});

export default i18n;
